import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { NewLoginForm } from '../components/NewLoginForm';

const NewLoginPage: React.FC = () => {
    const { t } = useTranslation('auth');
    const [searchParams] = useSearchParams();
    const resetSuccess = searchParams.get('reset') === 'success';

    return (
        <div className="mx-auto">
            <div className="md:grid md:grid-cols-[55%_45%] text-body-text h-svh min-height pt-4 md:pt-0">
                <div className="flex w-full justify-center md:items-center">
                    <div className="w-96 md:p-0 p-8">
                        <h2 className="text-2xl md:text-[28px] font-bold py-2 text-card-title">
                            {t('login.title', 'Iniciar Sesión')}
                        </h2>
                        <p className="text-sm leading-relaxed pb-4">
                            {t('login.description', 'Ingresa tus credenciales para continuar')}
                        </p>
                        {resetSuccess && (
                            <div className="mb-4 p-4 bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-800 rounded-md">
                                <p className="text-sm text-green-700 dark:text-green-300">
                                    {t('resetPassword.success', 'Contraseña restablecida exitosamente')}
                                </p>
                            </div>
                        )}
                        <NewLoginForm />
                    </div>
                </div>

                <div className="h-full w-full items-center justify-center bg-element-bg hidden md:flex">
                    <div className="fixed top-0 right-0 pt-8 px-10">
                        <img
                            src="/imagen/logo_beeping_white.svg"
                            alt="logo"
                            className="w-[180px] h-[26px] object-contain"
                        />
                    </div>
                    <div className="flex flex-col justify-center items-center pt-11 w-96">
                        <div className="">
                            <h1 className="font-bold text-[35px]">
                                {t('login.welcome', '¡Bienvenido de vuelta!')}
                            </h1>
                        </div>

                        <div className="flex justify-center items-center gap-4 w-[384px]">
                            <img src="/imagen/login.png" className="object-contain" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewLoginPage; 